import { Component } from '@angular/core';

// services, models, environment
import { CommonService } from '../../services/common-service';

@Component({
  selector: 'main-footer',
  imports: [],
  templateUrl: './main-footer.html',
  styleUrl: './main-footer.css'
})
export class MainFooter {

  public appVersion: string| null = null;
  public footer: string | undefined;
  constructor( private _commonService: CommonService )
  {
    this.loadAppVersion();
  }

  private async loadAppVersion(): Promise<void> {   
      this.appVersion = await this._commonService.getAppVersion();
    this.footer = `Copyright © ${new Date( Date.now() ).getFullYear()} - ${this.appVersion}`;
  }

}
